import React from "react";
import { Truck, Award, Eye } from "lucide-react";
import { useTranslation } from "../lib/i18n";

export default function FeaturesSection() {
  const { t } = useTranslation();

  const icons = [
    <Truck key="i1" className="w-10 h-10 text-white" />,
    <Award key="i2" className="w-10 h-10 text-white" />,
    <Eye key="i3" className="w-10 h-10 text-white" />,
  ];

  const features = [
    { title: t("feature1Title"), text: t("feature1Text"), highlight: t("feature1Highlight") },
    { title: t("feature2Title"), text: t("feature2Text"), highlight: t("feature2Highlight") },
    { title: t("feature3Title"), text: t("feature3Text"), highlight: t("feature3Highlight") },
  ];

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 items-start text-center">
          {features.map((f, i) => (
            <div key={i} className="px-4">
              <div className="w-28 h-28 rounded-full bg-sky-800 text-white mx-auto flex items-center justify-center shadow-lg">
                <div className="w-10 h-10 text-white">{icons[i]}</div>
              </div>

              <h3 className="mt-6 text-lg font-semibold tracking-wide uppercase">{f.title}</h3>
              <p className="mt-4 text-foreground/80">{f.text} <span className="text-red-600 font-semibold">{f.highlight}</span></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
